import { useEffect } from 'react';

import { eventHub } from '../../pm-plugins/ai-event-hub/event-hub';

export const useEditorAIReplacingTitle = (
	enabled: boolean,
	handleNewTitle: (title: string) => void,
) => {
	useEffect(() => {
		if (!enabled) {
			return;
		}

		const { unsubscribe } = eventHub.subscribe({
			event: 'replace title in confluence',
			callback: (data) => {
				handleNewTitle(data.title);
			},
		});

		return () => {
			unsubscribe();
		};
	}, [handleNewTitle, enabled]);
};
